export enum OrderStatus {
    failed,
    pending,
    accepted,
}
